/********************************************************************************
 * Copyright (c) 2020 TypeFox and others
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 ********************************************************************************/
import { createRoute } from '../../utils';
export var AdminDashboardRoutes;
(function (AdminDashboardRoutes) {
    AdminDashboardRoutes.ROOT = 'admin-dashboard';
    AdminDashboardRoutes.MAIN = createRoute([AdminDashboardRoutes.ROOT]);
    AdminDashboardRoutes.STATISTICS = createRoute([AdminDashboardRoutes.ROOT, 'statistics']);
    AdminDashboardRoutes.NAMESPACE_ADMIN = createRoute([AdminDashboardRoutes.ROOT, 'namespaces']);
    AdminDashboardRoutes.EXTENSION_ADMIN = createRoute([AdminDashboardRoutes.ROOT, 'extensions']);
    AdminDashboardRoutes.PUBLISHER_ADMIN = createRoute([AdminDashboardRoutes.ROOT, 'publisher']);
    AdminDashboardRoutes.SCANS_ADMIN = createRoute([AdminDashboardRoutes.ROOT, 'scans']);
    AdminDashboardRoutes.TIERS = createRoute([AdminDashboardRoutes.ROOT, 'tiers']);
    AdminDashboardRoutes.SIZE_OVERRIDES = createRoute([AdminDashboardRoutes.ROOT, 'size-overrides']);
    AdminDashboardRoutes.CUSTOMERS = createRoute([AdminDashboardRoutes.ROOT, 'customers']);
    AdminDashboardRoutes.USAGE_STATS = createRoute([AdminDashboardRoutes.ROOT, 'usage']);
    AdminDashboardRoutes.SETTINGS = createRoute([AdminDashboardRoutes.ROOT, 'settings']);
    AdminDashboardRoutes.LOGS = createRoute([AdminDashboardRoutes.ROOT, 'logs']);
    AdminDashboardRoutes.ACCESS_CONTROL = createRoute([AdminDashboardRoutes.ROOT, 'access-control']);
    AdminDashboardRoutes.CONSISTENCY = createRoute([AdminDashboardRoutes.ROOT, 'consistency']);
    AdminDashboardRoutes.CACHES = createRoute([AdminDashboardRoutes.ROOT, 'caches']);
    AdminDashboardRoutes.ANALYTICS_STATUS = createRoute([AdminDashboardRoutes.ROOT, 'analytics-status']);
    AdminDashboardRoutes.SEARCH_INDEX = createRoute([AdminDashboardRoutes.ROOT, 'search-index']);
    AdminDashboardRoutes.SEARCH_EXPLAIN = createRoute([AdminDashboardRoutes.ROOT, 'search-explain']);
})(AdminDashboardRoutes || (AdminDashboardRoutes = {}));
//# sourceMappingURL=admin-dashboard-routes.js.map